import { isValidPhoneNumber } from 'react-phone-number-input';
import * as Yup from 'yup';

export interface FormValues {
  address: string;
  phoneNumber?: string;
  isAddressPublic?: boolean;
  isPhoneNumberPublic?: boolean;
}

const isPhoneNumberValid = (value: string | undefined) => {
  if (value) {
    return isValidPhoneNumber(value);
  }
  return true;
};

export const validationSchema = Yup.object().shape({
  address: Yup.string().max(250).required('bookings.inPersonConsultationsStep.addressMandatory'),
  phoneNumber: Yup.string()
    .optional()
    .test('phoneNumber', 'addNewClient.validations.phoneNumberValid', isPhoneNumberValid),
});
